<!--
 * @description:
 * @author: cuicui
 * @Date: 2022-11-29 20:26:41
 * @LastEditTime: 2025-09-09 15:41:32
 * @LastEditors: fusiyuan 1152054863@qq.com
-->
<template>
  <router-link :to="bg(type).to" class="home-wait-panel__wrapper">
    <img
      :src="require('@/assets/images/homeIcon/' + bg(type).img)"
      :style="{ backgroundColor: bg(type).color }"
    />
    <div>
      <div class="header-title">
        {{ bg(type).name }}
      </div>
      <div class="body-data">
        <span>{{ data.total || 0 }}</span>
        <span>今日&nbsp;+{{ data.increase || 0 }}</span>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "HomeWaitPanel",
  props: ["type", "data"],
  methods: {
    bg(type) {
      switch (type) {
        case "goods":
          return {
            color: "#005bff",
            img: "bg-wait.png",
            name: "商品待审核",
            to: "/goodsNotReviewed",
          };
        case "works":
          return {
            color: "#f5b160",
            img: "bg-wait.png",
            name: "作品待审核",
            to: { path: "/listWorks", query: { status: "1" } },
          };
        case "withdraw":
          return {
            color: "#00bd83",
            img: "bg-wait.png",
            name: "提现待审核",
            to: { path: "/settlement", query: { withdrawStatus: "1" } },
          };
        case "users":
          return {
            color: "#00aaff",
            img: "bg-wait.png",
            name: "身份认证待审核",
            to: { path: "/users", query: { state: "WAITING" } },
          };
        case "shop":
          return {
            color: "#ff6653",
            img: "bg-wait-openshop.png",
            name: "开店认证待审核",
            to: { path: "/shop", query: { state: "WAITING" } },
          };
        case "contract":
          return {
            color: "#ff6653",
            img: "bg-wait-openshop.png",
            name: "签约待审核",
            to: { path: "/contractManagement", query: { status: 1 } },
          };
        case "bqdj":
          return {
            color: "#002b9c",
            img: "bg-wait.png",
            name: "普通版权登记待处理",
            to: { path: "/general", query: { status: "waiting_for_approval" } },
          };
        case "szbqdj":
          return {
            color: "#005bff",
            img: "bg-wait.png",
            name: "数字版权登记待处理",
            to: { path: "/digitalRights", query: { status: "waitAudit" } },
          };
        case "fpdcl":
          return {
            color: "#03539e",
            img: "bg-wait.png",
            name: "发票待处理",
            to: {
              path: "/bill",
              query: { status: "开票中" },
            },
          };
        case "bqwqdcl":
          return {
            color: "#6a8ae2",
            img: "bg-wait.png",
            name: "版权维权待处理",
            to: {
              path: "/copyrightProtection",
              query: { status: "inProgress" },
            },
          };
        default:
          return {};
      }
    },
  },
};
</script>

<style lang="scss">
.home-wait-panel__wrapper {
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  width: 302px;
  height: 126px;
  box-shadow: 0px 6px 12px 0px rgba(0, 43, 156, 0.3);
  cursor: pointer;
  &:not(:last-of-type) {
    margin-right: 20px;
  }
  img {
    height: 100%;
    width: 100%;
  }
  & > div {
    color: white;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    padding: 23px 40px 14px;
  }
  .header-title {
    height: 22px;
    line-height: 22px;
    font-size: 16px;
    font-weight: 500;
  }
  .body-data {
    margin-top: 34px;
    height: 33px;
    line-height: 33px;
    font-size: 24px;
    font-weight: 500;
    span:last-of-type {
      opacity: 0.7;
      font-weight: 400;
      font-size: 20px;
      float: right;
      word-spacing: 10px;
    }
  }
}
</style>
